<template>
  <div>
    <v-toolbar dense tabs color="primary darken-2" dark class="page_title">
      <v-toolbar-title class="pa-0 pr-0 mt-1">
        <v-layout row>
          <v-flex xs10 sm11 text-xs-left>
            <a href="javascript: history.go(-1)" class="pa-0">
              <v-btn flat fab small class="pa-0" aria-label="Go back">
                <i class="fas fa-arrow-left headline"></i>
              </v-btn>
            </a>
            Reset Password
          </v-flex>
          <v-flex xs2 sm1 text-xs-right>
            <router-link :to="$store.state.close_url" class="pa-0 text-xs-right">
              <v-btn flat fab small class="pa-0" aria-label="Close">
                <i class="fas fa-close headline"></i>
              </v-btn>
            </router-link>
          </v-flex>
        </v-layout>
      </v-toolbar-title>
    </v-toolbar>

    <v-container>
      <v-layout row>
        <v-flex xs12 md8 offset-md2 lg6 offset-lg3>
          <v-slide-y-transition mode="out-in">
            <div>
              <v-card class="blue lighten-4">
                <v-card-text style="font-size: 12px;">
                  <p class="dark--text subheading pa-0 ma-0 text-xs-center">
                    <span>Please enter your new password below.</span>
                  </p>
                </v-card-text>
              </v-card>
              <v-card color="white pa-3" class="white-bg">
                <v-layout row>
                  <v-flex xs12 md10 offset-md1>
                    <!-- Champ pour le nouveau mot de passe -->
                    <v-text-field
                      id="new_password"
                      label="New Password"
                      type="password"
                      single-line
                      color="teal"
                      v-model="newPassword"
                    ></v-text-field>

                    <!-- Champ pour confirmer le nouveau mot de passe -->
                    <v-text-field
                      id="confirm_password"
                      label="Confirm New Password"
                      type="password"
                      single-line
                      color="teal"
                      v-model="confirmPassword"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <div class="text-xs-center">
                  <v-btn
                    class="white--text elevation-6"
                    round
                    color="teal darken-2"
                    @click="resetPassword"
                    :disabled="!isFormValid"
                  >
                    <span>Reset Password</span>
                  </v-btn>
                </div>
              </v-card>
            </div>
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
    </v-container>

  <v-dialog v-model="showSuccessDialog" max-width="400" persistent>
    <v-card class="text-center success-dialog">
 
      <v-icon
        size="64"
        color="teal darken-2"
        class="mt-6"
      >
        mdi-check-circle-outline
      </v-icon>

  
      <v-card-title class="headline justify-center teal--text text--darken-2">
        Success       <v-img
                          src="/logo.png"     
                          alt="Logo"
                          class="logo"
                      />
      </v-card-title>


      <v-card-text class="subtitle-1">
        Your password has been reset successfully. You will be redirected to the login page shortly.
      </v-card-text>


      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="teal darken-2"
          text
          @click="redirectToLogin"
          class="mb-4"
        >
          OK
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>



  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      newPassword: "", // Nouveau mot de passe
      confirmPassword: "", // Confirmation du nouveau mot de passe
      uid: this.$route.query.uid, // Récupère l'UID depuis l'URL
      token: this.$route.query.token, // Récupère le token depuis l'URL
      showSuccessDialog: false, // Contrôle l'affichage de la boîte de dialogue
    };
  },
  computed: {
    // Vérifie si le formulaire est valide
    isFormValid() {
      return (
        this.newPassword.length >= 8 &&
        this.newPassword === this.confirmPassword
      );
    },
  },
  mounted() {
    document.title = "PettyCash Savings | Reset Password";
    this.$store.commit("setCloseURL", "/");
  },
  methods: {
    async resetPassword() {
      if (!this.isFormValid) {
        alert("Please ensure the passwords match and are at least 8 characters long.");
        return;
      }

      try {
        const response = await axios.post(
          "/api/v1/home/reset/confirm/",
          {
            uid: this.uid,
            token: this.token,
            new_password: this.newPassword,
          }
        );

        if (response.status === 200) {
          this.showSuccessDialog = true; 
          setTimeout(() => {
            this.redirectToLogin(); 
          }, 3000);
        }
      } catch (error) {
        console.error(error);
        if (error.response && error.response.status === 400) {
          alert("Invalid or expired token. Please request a new password reset link.");
        } else {
          alert("An error occurred while resetting your password. Please try again later.");
        }
      }
    },
    redirectToLogin() {
      this.showSuccessDialog = false;
      this.$router.push("/login"); 
    },
  },
};
</script>

<style scoped>
.white-bg {
  background-color: rgb(255, 255, 255) !important;
}



.success-dialog {
  border-radius: 12px; /* Coins arrondis */
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2); /* Ombre plus prononcée */
}

.v-card__title {
  font-size: 24px; /* Taille du titre */
  font-weight: 600; /* Gras */
}

.v-card__text {
  font-size: 16px; /* Taille du texte */
  color: #616161; /* Couleur du texte */
}

.v-btn {
  font-weight: 500; /* Gras pour le bouton */
}

.logo {

    height: 40px;
    weight: 40px;
  }

</style>  